"use client";
import { styled, useTheme } from "@mui/material/styles";
import { Grid, Text, Link } from "@nxt-costco-com/forge-components";
import { ColorWhite, SpaceXs, SpaceSm, SpaceMd, RadiusMd, FontLineHeightSm, FontWeightDefault, FontSize600, FontSize200, FontSize700, FontSize300 } from "@nxt-costco-com/forge-design-tokens";
import { CostcoBox } from "../../Util/CostcoBox.js";
const AdTitleWrapper = styled(CostcoBox, {
  shouldForwardProp: (prop) => prop !== "titleBackgroundColor" && prop !== "isAdSetCostco"
})(
  ({ isAdSetCostco, titleBackgroundColor }) => ({
    ...isAdSetCostco ? {
      alignContent: "center",
      alignItems: "flex-end",
      borderRadius: "10px 10px 0 0",
      display: "flex",
      marginBottom: 0,
      padding: `${SpaceXs} 0px`
    } : {
      borderRadius: RadiusMd,
      marginBottom: SpaceMd,
      marginLeft: `-${SpaceSm}`
    },
    backgroundColor: titleBackgroundColor || ColorWhite
  })
);
const TitleTextLinkGridWrapper = styled(Grid, {
  shouldForwardProp: () => true
})(() => ({
  alignItems: "center",
  justifyContent: "space-between",
  margin: 0,
  padding: 0,
  width: "100%",
  // Using 100% !important to override specific external CSS rules// Note: 100% !important is used here to override a css style being applied with CSS selectors on one-fourt mix ad set costco's that breaks the title width
  flexBasis: "100% !important"
}));
const TitleGrid = styled(Grid, {
  shouldForwardProp: (prop) => prop !== "titleAlignment"
})(({ titleAlignment }) => ({
  margin: 0,
  padding: 0,
  textAlign: titleAlignment || "left",
  width: titleAlignment === "center" ? "100%" : "auto"
}));
const TitleText = styled(Text, {
  shouldForwardProp: (prop) => prop !== "isAdSetCostco"
})(() => ({
  fontWeight: FontWeightDefault,
  lineHeight: FontLineHeightSm,
  width: "100%"
}));
const LinkWrapperGrid = styled(Grid, {
  shouldForwardProp: () => true
})(() => ({
  alignContent: "center",
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "flex-end"
}));
const TitleLink = styled(Link)(() => ({
  alignItems: "center",
  display: "flex",
  gap: SpaceXs,
  textWrap: "nowrap"
}));
const TitleLinkDefaultStyles = () => {
  const theme = useTheme();
  return {
    [theme.breakpoints.up("md")]: {
      fontSize: FontSize300,
      marginBottom: `calc((${FontSize700} - ${FontSize300})/2)`
    },
    [theme.breakpoints.down("md")]: {
      fontSize: FontSize200,
      marginBottom: `calc((${FontSize600} - ${FontSize200})/2)`
    }
  };
};
export {
  AdTitleWrapper,
  LinkWrapperGrid,
  TitleGrid,
  TitleLink,
  TitleLinkDefaultStyles,
  TitleText,
  TitleTextLinkGridWrapper
};
